import { useMutation, useQueryClient } from "@tanstack/react-query";
import firmwareKlydosClient from "../../../api/firmware-klydos";

const useUpdateFirmwareKlydosMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["firmware-klydos", "update"],
    mutationFn: ({ id, klydosIds }: { id: string; klydosIds: string[] }) =>
      firmwareKlydosClient.updateFirmwareKlydosKlydos(id, klydosIds),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ["firmware-klydos"] }),
  });
};

export default useUpdateFirmwareKlydosMutation;
